import Img from "../assets/enrollment.jpg";
import React, { useEffect } from "react";
import { Box, useTheme } from "@mui/material";
import { env } from "../config/env";

export const Enrollment = () => {
  const theme = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ width: "100%", margin: "auto" }}>
      <br />
      <Box
        component="img"
        src={Img}
        alt="Landscape"
        sx={{
          width: "100%",
          maxWidth: "800px",
          height: "auto",
          display: "block",
          margin: "auto",
          borderRadius: "8px",

          [theme.breakpoints.down("sm")]: {
            maxWidth: "90%",
            borderRadius: "4px",
          },
        }}
      />
      <br />
      <br />
      <Box
        sx={{
          width: "100%",
          maxWidth: "900px",
          mx: "auto",
          height: "66vh",
          "@media (max-width: 900px)": {
            height: "75vh",
          },
          "@media (max-width: 600px)": {
            height: "65vh",
          },
        }}
      >
        <iframe
          title="JotForm"
          src={env.enrollmentJotform}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
        ></iframe>
      </Box>
    </div>
  );
};
